import React from 'react';
import styles from './product-overview.module.css';
import { ProductOverview as ProductOverviewProp } from '../../typescript/component';
import GenericSmallCard from '../cards/generic-small-card';

interface ProductOverviewProps {
  product_overview: ProductOverviewProp;
  noGap?: boolean;
}

export default function ProductOverview({ product_overview, noGap = false }: ProductOverviewProps) {
  if (!product_overview) return null;

  const { title, summary, small_card } = product_overview;

  const cards = Array.isArray(small_card) ? small_card.slice(0, 4) : [];
  const sanitizedSummary = typeof summary === 'string' ? summary : '';

  return (
    <div className={styles.root}>
      <section className={`${styles.content} ${noGap ? styles.noGap : ''}`}>
        {title && <h3 className={styles.overview}>{title}</h3>}
        <div className={styles.cardGrid}>
          {cards.map((card, index) => (
            <GenericSmallCard key={card?.title ?? `card-${index}`} small_card={card} />
          ))}
        </div>
      </section>
      {sanitizedSummary && (
        <section className={styles.loremIpsumDolorContainer}>
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizedSummary,
            }}
          />
        </section>
      )}
    </div>
  );
}
